import ComboWizard from '../shared/combo-wizard'
import { interpretStep } from './functions'
import { ABUNDANCIA_CONSCIENTE_NAME, ABUNDANCIA_CONSCIENTE_STEPS } from './combo-config'

const AbundanciaConsciente = () => (
    <ComboWizard
        comboName={ABUNDANCIA_CONSCIENTE_NAME}
        steps={ABUNDANCIA_CONSCIENTE_STEPS}
        bgClass="bg-abundancia-consciente"
        interpretStep={interpretStep}
        consultaPlaceholder="Inquietud del consultante sobre dinero, abundancia o prosperidad (opcional). Se usará en las 3 tiradas del combo."
    />
)

export default AbundanciaConsciente
